import React, { Component } from 'react';
import { Button, Form, FormGroup, Label, Input, FormText, FormFeedback, InputGroup, InputGroupAddon, InputGroupText, Container, Col, Row } from 'reactstrap';
import * as urls from '../urls'
import LoadingSpinner from '../components/LoadingSpinner';


class KIRContainer extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            tagFromList:'',
            newTag: '',
            isNewTag: false,
            comment: '',
            validForm: false,
            error: ''
        };

        // this.selectedTag = React.createRef();
        
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleNewTagChange = this.handleNewTagChange.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.handleNewTagOptInChange = this.handleNewTagOptInChange.bind(this);

        this.validateForm = this.validateForm.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSelectChange(event){
        this.setState({
            tagFromList: [...event.target.selectedOptions].map(o => o.value)
        }, () => {this.validateForm();});
    }

    handleNewTagChange(event){
        this.setState({ 
            newTag: (event.target.value).trim()
        }, () => {this.validateForm();});
    }

    handleCommentChange(event){
        this.setState({
            comment: (event.target.value).trim()
        }, () => {this.validateForm();});
    }

    handleNewTagOptInChange(event){
        const isChecked = event.target.checked
        this.setState({
            isNewTag: isChecked,
        }, () => {this.validateForm();});
    }

    buildReqBody(){
        const body = {};
        body.Tag = this.state.isNewTag? `KIR_Exception: ${this.state.newTag}` :`${this.state.tagFromList}`;

        if (this.state.comment !== ""){
            body.Comment = this.state.comment;
        }

        return body 
    }

    buildReq(){
        const reqBody = JSON.stringify(this.buildReqBody())
        const headers = new Headers();
        headers.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'PUT',
            headers: headers,
            body: reqBody,
        };

        return requestOptions
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({
            loading: true
        })

        const reqOptions =  this.buildReq()
        fetch(`${urls.urls.newBaseUrl}${urls.setKIRUpdates(this.props.bugId)}`, reqOptions)
        .then(response => {
            if(response.status !== 200) {
              this.handleFormError(response);
              throw Error(response.statusText);
            }
            return response.json();
        }).then(() => {
            window.location = `https://microsoft.visualstudio.com/os/_git/os.2020/pullrequest/${this.props.changeId}`;
          }).catch(error => {
            console.log(error);
          });
    }

    handleError = response => {
        response.then(error => {
            this.setState({
                error: error.message || error,
                loading: false
            })
        })
    }

    handleFormError = response => {
        response.then(error => {
          this.setState(
            prevState => ({
              ...prevState,
              loading: false,
              error: error
            })
          );
    
          console.log(error);
        });
    }

    handleFormClose = e => {
        e.preventDefault();
        window.location = `https://microsoft.visualstudio.com/os/_git/os.2020/pullrequest/${this.props.changeId}`
    }

    validateForm(){
        var valid = false
        const isNewTag = this.state.isNewTag
        const isNewTagField = this.state.newTag === ''
        const isTagFromList = this.state.tagFromList === ''
        const isEmptyComment = this.state.comment === ''
        valid = (isNewTag && !isNewTagField && !isEmptyComment)
        || (!isNewTag && !isTagFromList && isEmptyComment)
        || (!isNewTag && !isTagFromList && !isEmptyComment)
        
        this.setState({validForm: valid})
    }
    
    render() {
        const generateAvailableOptions = (obj) =>{
            const options = []
            Object.keys(obj).forEach((k) => {
                options.push(<option key={k} value={k} title={obj[k]}>{k}</option>);
            })
            return options
        }
        const generateExistingTags = (list) =>{
            const tags = []
            list.forEach((e) => {
                tags.push(<Col key={e} xs="auto">{e}</Col>);
            })
            return tags
        }


        const existingTagPanel = () =>{
            if (this.props.kirTags.presentTags.length === 0)
            return <></>
            else{
                return <Form>
                <FormText className="h5">Current KIR tags in the bug:</FormText>
                <FormText className="h6" color="primary">These tags will be replaced with the new tag you select</FormText>
                <Container fluid>
                    <Row>
                        {existingTags}
                    </Row>
                </Container>
            </Form>
            }
        }

        const availableOptions = generateAvailableOptions(this.props.kirTags.availableTags)
        const existingTags = generateExistingTags(this.props.kirTags.presentTags)

        const { loading, error } = this.state;
        if (loading)
          return <LoadingSpinner />
    
        if (error !== '') {
          alert(error);
        }
        return (
            <>
            <Form onSubmit={this.handleSubmit}>
                <Label className="h6"> Non-MSRC bugs for RS1 as well as RS4 and above require a KIR tag. Please add one of valid KIR. Check KIR developer guide <a href="https://osgwiki.com/wiki/CSD_Wiki-KIR_Developer_Guide"  target="_blank" rel="noopener noreferrer">wiki</a> for more info</Label>
                <FormGroup>
                    <Label for="selectMultiOptions">Select A Tag:</Label>
                    <Input type="select" name="select" id="selectMultiOptions" onChange={this.handleSelectChange} size={availableOptions.length.toString()} disabled={this.state.isNewTag}>
                        {availableOptions}
                    </Input>
                    <FormText className="h6" color="info">Hover over item to see description</FormText>
                    <br/>
                    <FormGroup check inline>
                        <Input type="checkbox" name="check" id="newTagCheck" onChange={this.handleNewTagOptInChange}/>
                    <Label check for="newTagCheck">
                        My tag is not in the list, I would like to create a new one
                    </Label>
                    </FormGroup>
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText >KIR_Exception: </InputGroupText>
                        </InputGroupAddon>
                        <Input type="text" placeholder={`prefix will be prepended automatically to your tag`} onChange={this.handleNewTagChange} id="newTagText" disabled={!this.state.isNewTag}/>
                    </InputGroup>
                    <br/>
                    <Label for="commentText">Comment:</Label>
                    <Input 
                        type="textarea"
                        name="comment"
                        id="commentText"
                        placeholder={`add comment to the bug`}
                        onChange={this.handleCommentChange}
                        invalid={(this.state.isNewTag && this.state.comment === "")}
                        />
                    <FormFeedback>*Comment is required when you create a new tag</FormFeedback>
                </FormGroup>
                
                <Button title="submit and redirect back to PR"color={this.state.validForm?  'success': 'secondary'} type="submit" disabled={!this.state.validForm}>Submit</Button>{' '}
                <Button title="cancel and return back to PR"color='danger' onClick={this.handleFormClose}>Cancel</Button>
            </Form>
            <br/>
            {existingTagPanel()}      
            </>
            );
        }
    }
export default KIRContainer;